import { ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PrintchallanComponent } from 'src/app/printchallan/printchallan.component';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { SaveAssignRepresentativeDistributerDailogComponent } from '../save-assign-representative-distributer-dailog/save-assign-representative-distributer-dailog.component';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-hand-delivery',
  templateUrl: './hand-delivery.component.html',
  styleUrls: ['./hand-delivery.component.scss'],
})
export class HandDeliveryComponent implements OnInit {
  handdeliverydata;
  tempdata = [];
  data1: any;
  Filteredhanddeliverydata = [];
  total_sub_count = 0;
  total_s_bhet = 0;
  name;
  disRepData = [];
  issuedate: any;
  FilteredlabelsforDispatch: any;
  amount = [];
  names = [];
  issuedatenew: any;
  challanname: any;
  combinedList: any;
  combinedList1: any = [];
  total_saprem_bhet: number;
  total_sub: any;
  unqiuelist: any;
  name1: any;
  dis_mode: any;
  dis_sub_mode: any;
  dist_name: any;
  // inputValue:number
  constructor(
    private dialogref: MatDialogRef<HandDeliveryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,
    private router: Router,
    private service: DigisubservicesService, private cdr: ChangeDetectorRef
  ) { }
  updateStatus: any = false
  state: any
  district: any
  dispatchankDate: any
  type: any
  taluka: any
  pincode: any
  today: any
  vitarandate: any
  country: any
  totalIssueSellAmount: any = 0
  issueSellerData: any = []
  ngOnInit(): void {
    debugger;
    this.today = formatDate(new Date(), 'dd/MM/yyyy', 'en-IN', 'GMT+0530');
    // console.log(this.Filteredhanddeliverydata, "Filteredhanddeliverydata tapal")
    // console.log(this.data1, "Filteredhanddeliverydata tapal")
    this.name = this.data['name'];
    this.dis_mode = this.data.dis_mode;
    this.dis_sub_mode = this.data.dis_sub_mode;
    this.dist_name = this.data.dist_name;
    this.data1 = this.data['data1']
    this.issuedate = this.data['isuuedate'];
    this.amount = this.data['']
    this.dispatchankDate = this.data['dispatchdate'];
    this.type = this.data['type']
    this.handdeliverydata = this.data['data'];
    this.name1 = this.data['name'];
    this.updateStatus = this.data['updateStatus']
    this.state = this.data.state;
    this.district = this.data.district;
    this.taluka = this.data.taluka,
      this.pincode = this.data.pincode,
      this.vitarandate = this.data.vitarandate,
      this.country = this.data.country,
      //  this.dispatchankDate = this.calculatePublishDate(this.issuedate);

      console.log(this.handdeliverydata, " this.data")
    console.log(this.data1, " this.data1")
    console.log(this.name1, " this.name1")
    const req1: any = {
      "issue_date": this.issuedate
    }
    debugger

    if (this.updateStatus) {
      debugger
      this.service.getnewapi2(req1).subscribe((res) => {
        this.issueSellerData = res.data;
        console.log(this.issueSellerData)
        this.combinedList = this.handdeliverydata;
        console.log(this.combinedList, "Intial list")

        for (let j = 0; j < this.data1.length; j++) {
          let matchFound = false;

          for (let i = 0; i < this.combinedList.length; i++) {
            // toInt(item['sub_count']) + toInt(item['ISSUE_SELLER_COPIES']) + toInt(item['s_bhet']) + (+item.inputValue || 0)
            // Check if `dis_rep_name` matches `dsi_rep`
            if (this.combinedList[i].issueSellerName === this.data1[j].dsi_rep) {
              // Update the existing object
              if (Number(this.data1[j].master_count) != 0 || Number(this.data1[j].ISSUE_SELLER_COPIES) != 0 || Number(this.combinedList[i].s_bhet) != 0 || Number(this.data1[j].copy1) != 0) {
                console.log(this.combinedList[i].issueSellerName, "=>", this.data1[j].count)
                this.combinedList[i].sub_count = this.data1[j].master_count;
                this.combinedList[i].dis_dist = this.data1[j].district != "" ? this.data1[j].district : this.combinedList[i].district;
                this.combinedList[i].dis_tal = this.data1[j].taluka != "" ? this.data1[j].taluka : this.combinedList[i].taluka;
                this.combinedList[i].dis_mode = this.data1[j].dis_mode;
                this.combinedList[i].dis_sub_mode = this.data1[j].dis_sub_mode;
                this.combinedList[i].dis_s_bhet = 0;
                // this.combinedList[i].inputValue = this.data1[j].copy1;
                this.combinedList[i].inputValue = this.toInt(this.data1[j].copy1);
                this.combinedList[i].selected = false;
                this.combinedList[i].pincode = this.data1[j].pincode;
                this.combinedList[i].state = this.data1[j].state;
                this.combinedList[i].country = this.data1[j].country;
                this.combinedList[i].s_bhet = this.combinedList[i].s_bhet || 0;
                this.combinedList[i].ISSUE_SELLER_COPIES = this.data1[j].ISSUE_SELLER_COPIES;
                matchFound = true; // Set match found flag to true
                break; // Exit the loop as we've found a match
              }
            }
          }
          

          // If no match was found, add a new object to `combinedList`
          if (!matchFound) {
            if (Number(this.data1[j].master_count) != 0 || Number(this.data1[j].ISSUE_SELLER_COPIES) != 0 || Number(this.data1[j].copy1) != 0) {
              const newEntry = {
                issueSellerName: this.data1[j].dsi_rep,
                // sub_count: this.data1[j].count,
                dis_dist: this.data1[j].district,
                dis_tal: this.data1[j].taluka,
                dis_mode: this.data1[j].dis_mode,
                dis_sub_mode: this.data1[j].dis_sub_mode,
                issue_seller_id: this.data1[j].issue_seller_id,
                assign_distributer_id: this.data1[j].assign_distributer_id,
                // inputValue: this.data1[j].copy1,
                inputValue: this.toInt(this.data1[j].copy1),
                pincode: this.data1[j].pincode,
                state: this.data1[j].state,
                country: this.data1[j].country,
                ISSUE_SELLER_COPIES: this.data1[j].ISSUE_SELLER_COPIES,
                s_bhet: this.data1[j].s_bhet || 0,
                sub_count: this.data1[j].master_count,
              };
              this.combinedList.push(newEntry); // Add new object to `combinedList`
            }

          }
        }
        //Old Code
        // const uniqueMap = new Map<string, any>();

        // // First, populate map from combinedList (original list)
        // this.combinedList.forEach((item: any) => {
        //   uniqueMap.set(item.issueSellerName, { ...item }); // clone to avoid reference issues
        // });

        // // Now update ISSUE_SELLER_COPIES from issueSellerData if matched
        // this.issueSellerData.forEach((element: any) => {
        //   const existing = uniqueMap.get(element.distribution_rep);
        //   if (existing) {
        //     existing.ISSUE_SELLER_COPIES = element.ISSUE_SELLER_COPIES;
        //     uniqueMap.set(element.distribution_rep, existing);
        //   } else {
        //     // If not found, use element itself but make sure to use issueSellerName key
        //     uniqueMap.set(element.distribution_rep, { ...element, issueSellerName: element.distribution_rep });
        //   }
        // });

        const uniqueMap = new Map<string, any>();

        // 🔴 Normalize function (IMPORTANT)
        const normalize = (val: any) =>
          (val || '').toString().trim().toLowerCase();

        // First fill from combinedList
        this.combinedList.forEach((item: any) => {
          const key = normalize(item.issueSellerName);
          uniqueMap.set(key, { ...item });
        });

        // Merge ISSUE_SELLER_COPIES safely
        this.issueSellerData.forEach((element: any) => {
          const key = normalize(element.distribution_rep);

          const existing = uniqueMap.get(key);

          if (existing) {
            existing.ISSUE_SELLER_COPIES = element.ISSUE_SELLER_COPIES;
            uniqueMap.set(key, existing);
          } else {
            uniqueMap.set(key, {
              ...element,
              issueSellerName: element.distribution_rep
            });
          }
        });

        // Final unique list
        this.combinedList1 = Array.from(uniqueMap.values());


        console.log(this.combinedList, "finale list"); // Check the final updated `combinedList`

        //Old Correct Code
        // this.combinedList = this.combinedList.filter((a) => {
        //   let dismodeCondition = true;
        //   if (this.dis_mode != '' && this.dis_mode != undefined) {
        //     // dismodeCondition = this.dis_mode.includes(a['dis_mode']);
        //     dismodeCondition = a['dis_mode'] !== "" && this.dis_mode === a['dis_mode'];

        //   }

        //   let dis_subModeCondition = true;
        //   if (this.dis_sub_mode != '' && this.dis_sub_mode != undefined) {
        //     // dis_subModeCondition = this.dis_sub_mode.includes(a['dis_sub_mode']);
        //     dis_subModeCondition = a['dis_sub_mode'] !== "" && this.dis_sub_mode === a['dis_sub_mode'];

        //   }

        //   let dist_nameCondition = true;
        //   if (this.dist_name != '' && this.dist_name != undefined) {
        //     // dist_nameCondition = this.dist_name.includes(a['issueSellerName']);
        //     dist_nameCondition = a['issueSellerName'] !== "" && this.dist_name === a['issueSellerName'];
        //   }

        //   return (
        //     dismodeCondition &&
        //     dis_subModeCondition &&
        //     dist_nameCondition
        //     // Add more conditions here
        //   );
        // })

        //New Code 
        // this.combinedList1 = this.combinedList1.filter((a) => {

        //   let dismodeCondition = true;
        //   if (this.dis_mode !== '' && this.dis_mode !== undefined && this.dis_mode !== null) {
        //     dismodeCondition =
        //       a.dis_mode != null &&
        //       String(a.dis_mode).trim().toLowerCase() ===
        //       String(this.dis_mode).trim().toLowerCase();
        //   }

        //   let dis_subModeCondition = true;
        //   if (this.dis_sub_mode !== '' && this.dis_sub_mode !== undefined && this.dis_sub_mode !== null) {
        //     dis_subModeCondition =
        //       a.dis_sub_mode != null &&
        //       String(a.dis_sub_mode).trim().toLowerCase() ===
        //       String(this.dis_sub_mode).trim().toLowerCase();
        //   }

        //   let dist_nameCondition = true;
        //   if (this.dist_name !== '' && this.dist_name !== undefined && this.dist_name !== null) {
        //     dist_nameCondition =
        //       a.issueSellerName != null &&
        //       String(a.issueSellerName).trim().toLowerCase() ===
        //       String(this.dist_name).trim().toLowerCase();
        //   }

        //   return dismodeCondition && dis_subModeCondition && dist_nameCondition;
        // });


        this.combinedList1 = this.combinedList1
          .filter((a) => {

            let dismodeCondition = true;
            if (this.dis_mode !== '' && this.dis_mode !== undefined && this.dis_mode !== null) {
              dismodeCondition =
                a.dis_mode != null &&
                String(a.dis_mode).trim().toLowerCase() ===
                String(this.dis_mode).trim().toLowerCase();
            }

            let dis_subModeCondition = true;
            if (this.dis_sub_mode !== '' && this.dis_sub_mode !== undefined && this.dis_sub_mode !== null) {
              dis_subModeCondition =
                a.dis_sub_mode != null &&
                String(a.dis_sub_mode).trim().toLowerCase() ===
                String(this.dis_sub_mode).trim().toLowerCase();
            }

            let dist_nameCondition = true;
            if (this.dist_name !== '' && this.dist_name !== undefined && this.dist_name !== null) {
              dist_nameCondition =
                a.issueSellerName != null &&
                String(a.issueSellerName).trim().toLowerCase() ===
                String(this.dist_name).trim().toLowerCase();
            }

            return dismodeCondition && dis_subModeCondition && dist_nameCondition;
          })

          .filter(item => !this.isRowEmpty(item))

          // 🔴 THIS IS THE IMPORTANT PART
          .sort((a, b) => {

            const distA = (a.dis_dist || a.district || '').toLowerCase();
            const distB = (b.dis_dist || b.district || '').toLowerCase();

            if (distA !== distB) {
              return distA.localeCompare(distB);   // district sequence
            }

            const talA = (a.dis_tal || a.taluka || '').toLowerCase();
            const talB = (b.dis_tal || b.taluka || '').toLowerCase();

            return talA.localeCompare(talB);       // taluka sequence
          });


        this.total_saprem_bhet = 0;
        this.total_sub = 0;
        this.sumOfTotal = 0
        this.totalIssueSellAmount = 0
        for (let data1 of this.combinedList1) {
          this.total_saprem_bhet += parseInt(data1.s_bhet) || 0;
          this.total_sub += parseInt(data1.sub_count) || 0;
          this.totalCoies += parseInt(data1.inputValue) || 0;
          this.sumOfTotal = Number(this.sumOfTotal) + Number(data1.sub_count || 0) + Number(data1.s_bhet == undefined ? 0 : data1.s_bhet);
          this.totalIssueSellAmount = Number(this.totalIssueSellAmount) + Number(data1.ISSUE_SELLER_COPIES)
        }
        this.sumOfTotal1 = Number(this.sumOfTotal1) + Number(this.total_sub) + Number(this.total_saprem_bhet);
        this.sumOfTotal = Number(this.sumOfTotal) + Number(this.totalCoies) + Number(this.totalIssueSellAmount);
        console.log(this.total_saprem_bhet, this.total_sub, "finale total")



        this.tempdata = this.uniqueid(
          this.handdeliverydata,
          (a) => a['distribution_rep']
        );

        let arr = [];
        this.tempdata.map((a) => {
          arr.push(a.distribution_rep);
        });

        setTimeout(() => {
          this.disRepData = this.disRepData.filter(
            (a) => !arr.includes(a.dis_rep_name)
          );

        }, 600);
        this.amount = []
      });

    } else {
      debugger
      this.amount = []
      this.getDistrictwiseStatementList();
    }
    // this.sortDataRepresentativewise();
  }

  calculatePublishDate(issueDate: string): string {

    if (!issueDate) {
      return '';
    }

    const date = new Date(issueDate);

    // Publish Date = Issue Date - 6 Days
    date.setDate(date.getDate() - 6);

    return formatDate(
      date,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
  }

  printchallan() {


    this.dialog.open(PrintchallanComponent, {
      data: {
        issuedate: this.issuedatenew,
        amount: this.amount,
        names: this.names,
        vitarandate: this.dispatchankDate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  checkAll = false;
  masterSelected: boolean = false;
  selectedIds: string = "";
  checkboxcheck(event: any, value: any, name: any, rowItem: any) {
    this.issuedatenew = this.issuedate;
    rowItem.selected = event.target.checked;
    if (event.target.checked) {
      this.amount.push(value);
      this.names.push(name);
    } else {
      const valueIndex = this.amount.indexOf(value);
      if (valueIndex !== -1) this.amount.splice(valueIndex, 1);
      const nameIndex = this.names.indexOf(name);
      if (nameIndex !== -1) this.names.splice(nameIndex, 1);
    }
    this.masterSelected = this.combinedList.every(item => item.selected);
    const selectedItems = this.combinedList.filter(item => item.selected);
    this.selectedIds = selectedItems.map(item => item.id).join(',');
  }

  // sortDataRepresentativewise() {
  //   this.total_sub_count = 0;
  //   this.total_s_bhet = 0;
  //   for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
  //     let data = this.handdeliverydata.filter(
  //       (a) => a['distribution_rep'] == this.tempdata[index]['distribution_rep']
  //     );

  //     // console.log(data);
  //     let val =
  //       this.tempdata[index]['s_bhet'] === null
  //         ? 0
  //         : parseInt(this.tempdata[index]['s_bhet']);
  //     this.total_sub_count += Object.keys(data).length;
  //     this.total_s_bhet += val;

  //     // this.data1.push(data);
  //     this.Filteredhanddeliverydata.push({
  //       Subscription_Type: this.tempdata[index]['Subscription_Type'],
  //       address: this.tempdata[index]['address'],
  //       country: this.tempdata[index]['country'],
  //       delivery_mode: this.tempdata[index]['delivery_mode'],
  //       district: this.tempdata[index]['district'],
  //       entry_date: this.tempdata[index]['entry_date'],
  //       mobileNumber: this.tempdata[index]['mobileNumber'],
  //       name: this.tempdata[index]['name'],
  //       office_rep_name: this.tempdata[index]['office_rep_name'],
  //       pincode: this.tempdata[index]['pincode'],
  //       rep_mob_no: this.tempdata[index]['rep_mob_no'],
  //       rep_name: this.tempdata[index]['rep_name'],
  //       dis_rep_name: this.tempdata[index]['distribution_rep'],
  //       state: this.tempdata[index]['state'],
  //       sub_perid_to_date: this.tempdata[index]['sub_perid_to_date'],
  //       taluka: this.tempdata[index]['taluka'],
  //       title: this.tempdata[index]['title'],
  //       dis_mode: this.tempdata[index]['dis_mode'],
  //       dis_sub_mode: this.tempdata[index]['dis_sub_mode'],
  //       dis_add: this.tempdata[index]['dis_add'],
  //       dis_country: this.tempdata[index]['dis_country'],
  //       dis_dist: this.tempdata[index]['dis_dist'],
  //       dis_pin: this.tempdata[index]['dis_pin'],
  //       dis_state: this.tempdata[index]['dis_state'],
  //       dis_tal: this.tempdata[index]['dis_tal'],
  //       dis_s_bhet:
  //         this.tempdata[index]['s_bhet'] === null
  //           ? 0
  //           : this.tempdata[index]['s_bhet'],
  //       sub: Object.keys(data).length,
  //     });



  //   }

  //   this.sortDataByTaluka(this.Filteredhanddeliverydata)
  //   // console.log(this.data1);
  //   // console.log(this.Filteredhanddeliverydata);
  //   setTimeout(() => {
  //     this.disRepData.map((a) => {
  //       let val = a['dis_s_bhet'] === null ? 0 : parseInt(a['dis_s_bhet']);
  //       this.total_s_bhet += val;
  //       this.Filteredhanddeliverydata.push({
  //         Subscription_Type: '',
  //         address: '',
  //         country: '',
  //         delivery_mode: a['delivery_mode'],
  //         district: '',
  //         entry_date: '',
  //         mobileNumber: '',
  //         name: '',
  //         office_rep_name: '',
  //         pincode: '',
  //         rep_mob_no: '',
  //         rep_name: '',
  //         dis_rep_name: a['dis_rep_name'],
  //         state: '',
  //         sub_perid_to_date: '',
  //         taluka: '',
  //         title: '',
  //         dis_mode: a['dis_mode'],
  //         dis_sub_mode: a['dis_sub_mode'],
  //         dis_add: a['dis_add'],
  //         dis_country: a['dis_country'],
  //         dis_dist: a['dis_dist'],
  //         dis_pin: a['dis_pin'],
  //         dis_state: a['dis_state'],
  //         dis_tal: a['dis_tal'],
  //         dis_s_bhet: a['dis_s_bhet'] === null ? 0 : a['dis_s_bhet'],
  //         sub: 0,
  //       });
  //     });
  //     this.sortDataByTaluka(this.Filteredhanddeliverydata)
  //   }, 600);



  // }

  sortDataByTaluka(data) {
    data.sort((a, b) => {
      const nameA = a.dis_tal || '';
      const nameB = b.dis_tal || '';
      return nameA.localeCompare(nameB);
    });
  }

  assigndisrep(item) {
    // localStorage.setItem('goto', 'delivery_mode');
    this.dialogref.close({ data: 'refresh', val: item });
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  //Old Code
  // toInt(no: any) {
  //   if (no === undefined) {
  //     no = 0
  //   }

  //   return parseInt(no);
  // }

  //   toInt(no: any): number {
  //   const val = Number(no);
  //   return isNaN(val) ? 0 : val;
  // }

  toInt(value: any): number {
    return Number(value) || 0;
  }


  openSaveDialog(item: any) {
    console.log(item)
    const dialogRef2 = this.dialog.open(SaveAssignRepresentativeDistributerDailogComponent, {
      data: {
        issueSellerName: item.issueSellerName,
        id: item.assign_distributer_id,
        dis_mode: item.dis_mode,
        dis_sub_mode: item.dis_sub_mode,
        objectData: item
      },
      width: '700px',
      height: '400px',
      maxWidth: '100%',

    });

    dialogRef2.afterClosed().subscribe(result => {
      // console.log(this.combinedList);
      // console.log(result);

      const index = this.combinedList.findIndex(
        item => item.assign_distributer_id === result.assign_distributer_id
      );

      if (index !== -1) {
        this.combinedList[index] = result;
      }
      // alert('Received from Dialog2:');
    });
  }
  refreshData() {
    this.service.getSbhetdata(this.issuedate).subscribe((res) => {
      this.combinedList = res;

    });
  }
  addValueInTotal(object: any) {

    // const index = this.combinedList.findIndex(
    //   item => item.assign_distributer_id === object.assign_distributer_id
    // );

    // if (index !== -1) {
    //   this.combinedList[index] = object;
    // }
  }

  saveSubscriptionAllDistributer() {
    debugger
    // const filteredData = this.combinedList1.map((item) => ({
    //   issue_date: this.issuedate,
    //   // publish_date: this.convertDateFormat(this.dispatchankDate),
    //   publish_date: this.convertDateFormats(new Date(new Date(this.issuedate).getTime() - 6 * 24 * 60 * 60 * 1000)),
    //   country: this.country[0],
    //   state: item.state,
    //   district: item.dis_dist,
    //   taluka: item.dis_tal,
    //   pincode: item.pincode,
    //   distribution_mode: item.dis_mode,
    //   sub_distribution_mode: item.dis_sub_mode,
    //   dispatch_date: this.convertDateFormat(this.dispatchankDate),
    //   issue_seller_name: item.issueSellerName != undefined ? item.issueSellerName : "",
    //   issue_seller_id: item.issue_seller_id != undefined ? item.issue_seller_id : null,
    //   sale: item.ISSUE_SELLER_COPIES,
    //   subscriber: item.sub_count,
    //   delivery_mode: item.dis_mode,
    //   complementory_copies: item.s_bhet != undefined ? item.s_bhet : 0,
    //   copy: item.inputValue,
    //   copy1: item.inputValue1,
    //   copy2: item.inputValue2,
    //   price: item.price,
    //   total: Number(item.sub_count != undefined ? item.sub_count : 0) + Number(item.s_bhet != undefined ? item.s_bhet : 0) + Number(item.inputValue != undefined ? item.inputValue : 0) + Number(item.ISSUE_SELLER_COPIES != undefined ? item.ISSUE_SELLER_COPIES : 0) 
    //   + Number(item.inputValue1 != undefined ? item.inputValue1 : 0) + Number(item.inputValue2 != undefined ? item.inputValue2 : 0),
    //   input_value: item.inputValue,
    //   input_value1: item.inputValue1,
    //   input_value2: item.inputValue2
    // }));

    const filteredData = this.combinedList1.map((item) => ({

      issue_date: this.issuedate,

      publish_date: this.convertDateFormats(
        new Date(new Date(this.issuedate).getTime() - 6 * 24 * 60 * 60 * 1000)
      ),

      country: this.country?.[0] || "भारत",

      state: item.state || "",
      // district: item.dis_dist || "",
      // taluka: item.dis_tal || "",
      district: item.dis_dist || item.district || '',
      taluka: item.dis_tal || item.taluka || '',
      pincode: item.pincode || "",

      distribution_mode: item.dis_mode || "",
      sub_distribution_mode: item.dis_sub_mode || "",

      dispatch_date: this.convertDateFormat(this.dispatchankDate),

      issue_seller_name: item.issueSellerName || "",
      issue_seller_id: item.issue_seller_id ?? null,

      sale: Number(item.ISSUE_SELLER_COPIES || 0),
      subscriber: Number(item.sub_count || 0),

      delivery_mode: item.dis_mode || "",

      complementory_copies: Number(item.s_bhet || 0),

      copy: Number(item.inputValue || 0),

      input_value: Number(item.inputValue || 0),
      input_value1: Number(item.inputValue1 || 0),
      input_value2: Number(item.inputValue2 || 0),

      price: Number(item.price || 0),

      total:
        Number(item.sub_count || 0) +
        Number(item.s_bhet || 0) +
        Number(item.inputValue || 0) +
        Number(item.ISSUE_SELLER_COPIES || 0) +
        Number(item.inputValue1 || 0) +
        Number(item.inputValue2 || 0),

      status: 'A',
      added_by: 1,
      added_date_time: new Date().toISOString().slice(0, 19).replace('T', ' ')
    }));

    console.log(filteredData);
    console.log("FINAL JSON:", JSON.stringify(filteredData));
    this.service.saveAllDistributerEntry(filteredData).subscribe((data) => {
      alert('All Distribution List Save Successfully!');
    });
  }

  convertDateFormats(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2); // 0-padded month
    const day = ('0' + d.getDate()).slice(-2); // 0-padded day
    return `${year}-${month}-${day}`; // format: YYYY-MM-DD
  }


  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  convertDateFormatByDash(dateStr: string): string {
    const [day, month, year] = dateStr.split('-');
    return `${year}/${month}/${day}`;
  }

  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.combinedList.forEach(item => item.selected = this.checkAll);
    this.masterSelected = true;
    this.combinedList.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // let idsLength=this.selectedIds!=""?this.selectedIds.split(",").length:0;
    // let totalListLength=this.combinedList!=undefined?this.combinedList.length:0;
    // if(Number(idsLength)==Number(totalListLength)){
    //   this.masterSelected = true;
    // }else{
    //   this.masterSelected = false;
    // }
    this.masterSelected = this.combinedList.every(item => item.selected);
    const selectedItems = this.combinedList.filter(item => item.selected);
    this.selectedIds = selectedItems.map(item => item.id).join(',');

    // alert(this.selectedIds)
    // if (this.selectedIds == "") {
    //   this.deleteDistrictwiseStatemet = true;
    // } else {
    //   this.deleteDistrictwiseStatemet = false;
    // }
  }
  sumOfTotal: any
  // getDistrictwiseStatementList() {
  //   this.combinedList = []
  //   const request = {
  //     "issue_date": this.issuedate,
  //     "stateName": this.state,
  //     "districtName": this.district,
  //     "talukaName": this.taluka,
  //     "pincode": this.pincode,
  //     "distributionMode": this.dis_mode,
  //     "subDistributionMode": this.dis_sub_mode,
  //   }
  //   this.service.getAllDistributerCopiesList(request).subscribe((data: any) => {
  //     this.combinedList = data.data
  //     this.combinedList = this.combinedList.map(item => ({
  //       ...item,
  //       selected: false,
  //       inputValue: 0,
  //     inputValue1: 0,
  //     inputValue2: 0
  //     }));
  //     this.sumOfTotal = data.totals.sumOfTotal;
  //     // this.calculateTotal();
  //     this.combinedList1 = this.combinedList.filter(item => !this.isRowEmpty(item));
  //     // this.combinedList1=this.combinedList;
  //     this.calculateTotal();
  //   });
  // }

  //   getDistrictwiseStatementList() {

  //   this.combinedList = [];

  //   const request = {
  //     issue_date: this.issuedate,
  //     stateName: this.state,
  //     districtName: this.district,
  //     talukaName: this.taluka,
  //     pincode: this.pincode,
  //     distributionMode: this.dis_mode,
  //     subDistributionMode: this.dis_sub_mode,
  //   };

  //   this.service.getAllDistributerCopiesList(request).subscribe((data: any) => {

  //     this.combinedList = data.data.map(item => ({
  //       ...item,
  //       selected: false,

  //       // ✅ FIX: DON'T OVERRIDE EXISTING VALUES
  //       inputValue: this.toInt(item.inputValue),
  //       inputValue1: this.toInt(item.inputValue1),
  //       inputValue2: this.toInt(item.inputValue2)
  //     }));

  //     this.sumOfTotal = data.totals.sumOfTotal;

  //     // keep your existing logic
  //     this.combinedList1 = this.combinedList;

  //     // ✅ IMPORTANT: reset totals before calculation
  //     this.totalCoies = 0;
  //     this.totalCoies1 = 0;
  //     this.totalCoies2 = 0;

  //     this.calculateTotal();
  //   });
  // }


  getDistrictwiseStatementList() {

    this.combinedList = [];

    const request = {
      issue_date: this.issuedate,
      stateName: this.state,
      districtName: this.district,
      talukaName: this.taluka,
      pincode: this.pincode,
      distributionMode: this.dis_mode,
      subDistributionMode: this.dis_sub_mode,
    };

    this.service.getAllDistributerCopiesList(request).subscribe((data: any) => {

      // ✅ Extract dispatchdate from API response
      console.log(data.dispatchdate, data.data?.[0]?.dispatch_date)
      this.dispatchankDate =
        (data.dispatchdate && data.dispatchdate !== '') ? data.dispatchdate
          : (data.data?.[0]?.dispatch_date && data.data?.[0]?.dispatch_date !== '') ? data.data[0].dispatch_date
            : this.dispatchankDate;       // fallback to existing value

      console.log(this.dispatchankDate, "dispatchankDate from API"); // ✅ verify

      this.combinedList = data.data.map(item => ({
        ...item,
        selected: false,
        inputValue: this.toInt(item.inputValue),
        inputValue1: this.toInt(item.inputValue1),
        inputValue2: this.toInt(item.inputValue2)
      }));

      this.sumOfTotal = data.totals.sumOfTotal;

      this.combinedList1 = this.combinedList;

      this.totalCoies = 0;
      this.totalCoies1 = 0;
      this.totalCoies2 = 0;

      this.calculateTotal();
    });
  }

  deleteAllDistributerCopies() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deleteAllDistributerCopiesTotal(request).subscribe((data: any) => {
      alert("Deleted Successfully !!")
      this.getDistrictwiseStatementList();
    });
  }
  totalCoies: number = 0
  sumOfTotal1: number = 0
  totalCoies1: number = 0
  totalCoies2: number = 0

  //Old Code
  // calculateTotal() {
  //   this.sumOfTotal = 0
  //   this.sumOfTotal1 = 0
  //   this.totalCoies = 0
  //   this.total_saprem_bhet = 0;
  //   this.total_sub = 0;
  //   this.totalIssueSellAmount = 0;
  //   this.combinedList.forEach(element => {
  //     this.totalCoies = Number(this.totalCoies) + Number(element.inputValue);
  //     this.sumOfTotal = Number(this.sumOfTotal) + Number(element.sub_count) + Number(element.s_bhet == undefined ? 0 : element.s_bhet);
  //     this.total_saprem_bhet += Number(element.s_bhet == undefined ? 0 : element.s_bhet)
  //     this.total_sub += Number(element.sub_count || 0);
  //     this.totalIssueSellAmount = Number(this.totalIssueSellAmount) + Number(element.ISSUE_SELLER_COPIES)
  //   });
  //   // this.sumOfTotal1 = Number(this.total_sub) + Number(this.total_saprem_bhet) + Number(this.totalCoies);
  //   this.sumOfTotal1 = Number(this.totalCoies);
  //   this.sumOfTotal = Number(this.sumOfTotal) + Number(this.totalCoies) + Number(this.totalIssueSellAmount);
  // }

  // Old Correct Code
  // calculateTotal() {

  //   this.sumOfTotal = 0;
  //   this.sumOfTotal1 = 0;
  //   this.totalCoies = 0;
  //   this.totalCoies1 = 0;
  //   this.totalCoies2 = 0;
  //   this.total_saprem_bhet = 0;
  //   this.total_sub = 0;
  //   this.totalIssueSellAmount = 0;

  //   const list = this.combinedList1 || [];   // ⭐⭐⭐ USE THIS

  //   list.forEach(element => {

  //     const input = this.toInt(element.inputValue);
  //     const sub = this.toInt(element.sub_count);
  //     const bhet = this.toInt(element.s_bhet);
  //     const issue = this.toInt(element.ISSUE_SELLER_COPIES);
  //     const input1 = this.toInt(element.inputValue1);
  //     const input2 = this.toInt(element.inputValue2);

  //     this.totalCoies += input;
  //     this.total_sub += sub;
  //     this.total_saprem_bhet += bhet;
  //     this.totalIssueSellAmount += issue;
  //     this.totalCoies1 += input1;
  //     this.totalCoies2 += input2;

  //     // this.sumOfTotal += sub + bhet + input + issue + input1 + input2;
  //     this.sumOfTotal += (sub + bhet + issue + input + input1 + input2);
  //   });

  //   // this.sumOfTotal1 = this.totalCoies;
  //   this.sumOfTotal1 = this.total_sub + this.total_saprem_bhet + this.totalIssueSellAmount + this.totalCoies + this.totalCoies1 + this.totalCoies2;
  // }

  calculateTotal() {

    this.sumOfTotal = 0;
    this.sumOfTotal1 = 0;
    this.totalCoies = 0;
    this.totalCoies1 = 0;
    this.totalCoies2 = 0;
    this.total_saprem_bhet = 0;
    this.total_sub = 0;
    this.totalIssueSellAmount = 0;

    const list = this.combinedList1 || [];

    list.forEach(element => {

      const input = this.toInt(element.inputValue);
      const input1 = this.toInt(element.inputValue1);
      const input2 = this.toInt(element.inputValue2);
      const sub = this.toInt(element.sub_count);
      const bhet = this.toInt(element.s_bhet);
      const issue = this.toInt(element.ISSUE_SELLER_COPIES);

      this.totalCoies += input;
      this.totalCoies1 += input1;
      this.totalCoies2 += input2;

      this.total_sub += sub;
      this.total_saprem_bhet += bhet;
      this.totalIssueSellAmount += issue;

      this.sumOfTotal += (sub + bhet + issue + input + input1 + input2);
    });

    this.sumOfTotal1 =
      this.total_sub +
      this.total_saprem_bhet +
      this.totalIssueSellAmount +
      this.totalCoies +
      this.totalCoies1 +
      this.totalCoies2;
  }

  isRowEmpty(item: any): boolean {
    return (
      this.toInt(item.sub_count) === 0 &&
      this.toInt(item.s_bhet) === 0 &&
      this.toInt(item.inputValue) === 0 &&
      this.toInt(item.inputValue1) === 0 &&
      this.toInt(item.inputValue2) === 0 &&
      this.toInt(item.ISSUE_SELLER_COPIES) === 0
    );
  }

}
